import { Box, styled, Tab, Tabs } from "@mui/material";
import OrderDetails from "./OrderDetails";
import InvoiceList from "./InvoiceList";
import { usePermissions } from "../../context/PermissionsContext";
import { BOUNCER_PERMISSIONS } from "../../constants/bouncerPermissions";
import { useSearchParams } from "react-router-dom";
import { useEffect } from "react";

const CustomTabs = styled(Tabs)({
    '& .MuiTabs-indicator': {
      backgroundColor: '#3655F2',
      height: '4px',
      borderTopLeftRadius: '2px',
      borderTopRightRadius: '2px'
    },
    '& .MuiTab-root.Mui-selected': {
        color: "#3655F2"
    },
    '& .MuiTab-root': {
        textTransform: 'none'
    }
});

export default function InvoiceManagement() {
    const [searchParams, setSearchParams] = useSearchParams();
    const { hasPermission } = usePermissions();

    const showOrderTab = hasPermission(BOUNCER_PERMISSIONS.PO_VIEW);
    const showInvoiceTab = hasPermission(BOUNCER_PERMISSIONS.INVOICE_MANAGEMENT_VIEW);

    const defaultTab = showOrderTab ? "order" : "invoice";
    const activeTab = searchParams.get("tab") || defaultTab;

    useEffect(() => {
        if ((showOrderTab || showInvoiceTab) && !searchParams.get("tab")) {
            setSearchParams((prev) => {
                prev.set("tab", defaultTab);
                return prev;
            });
        }
    }, [showOrderTab, showInvoiceTab]) // eslint-disable-line react-hooks/exhaustive-deps

    const handleChange = (tab) => {
        setSearchParams((prev) => {
            prev.set("tab", tab);
            prev.set("filterData", "{}");
            prev.set("page", 1);
            prev.delete("status");
            prev.delete("filter_status");
            prev.delete("query");
            prev.delete("searchBy");
            return prev;
        });
    }

    return (
        <Box>
            <CustomTabs value={activeTab} sx={{backgroundColor: 'white', paddingLeft: '24px'}}>
                {showOrderTab && <Tab value="order" onClick={() => handleChange("order")} label="Order Details" />}
                {showInvoiceTab && <Tab value="invoice" onClick={() => handleChange("invoice")} label="Invoice Details" />}
            </CustomTabs>
            {activeTab === "order" && showOrderTab && <OrderDetails />}
            {activeTab === "invoice" && showInvoiceTab && <InvoiceList />}
        </Box>
    )
}